<axis-card>
  <axis-card-body>
    <h1 class="axis-h3">{{ disclosure?.title }}</h1>
    <p class="_text-bold">{{ disclosure?.subtitle }}</p>
    <ol class="_text-bold"> @for (item of disclosure?.selections; track item) { <li>
        <p>{{ item.label }}</p>
      </li> } </ol> @for (item of disclosure?.selections; track item) { <p>{{ item.content }}</p> } <p
      class="_text-bold"
    >Please make your selection below.</p>
    <p class="_text-bold">{{ disclosure?.instruction }}</p> @for (item of disclosure?.selections; track item) { <div
      class="axis-form-group"
    >
      <label class="axis-control-label _text-large">{{ item.heading }}</label>
      <axis-radio
        heading="{{ item.description }}"
        name="selection"
        value="{{ item.description }}"
        (change)="onSelection(item.type)"
        [checked]="item.checked"
      >
      </axis-radio>
    </div> }
  </axis-card-body>
</axis-card>
<div class="axis-btn-wrapper">
  <div class="axis-btn-wrapper-right">
    <button
      axis-button
      class="kind-primary"
      (click)="onContinue()"
    >
      <span class="axis-btn-icon-text">Continue</span>
    </button>
  </div>
</div>
